import React, { useState } from 'react';

import { Box } from '@mui/material';
import Header from '../../Header/Header';
import ManageContestsPanel from './ManageContestsPanel';
import ManageContestsSheet from './ManageContestsSheet';
import contestService from '../../../services/ContestService'
import { uploadArchive } from '../../../services/FileUploadService';
import { getStyles } from './styles';
import ContentCourseSelector from '../../Common/Selectors/ContentCourseSelector';
import { useTheme } from '@mui/material/styles';

export enum UploadType {
    New = 'New',
    Update = 'Update',
}

export default function ManageContests() {
  const theme = useTheme();
  const styles = getStyles(theme);
  const [uploadType, setUploadType] = useState<UploadType>('' as UploadType);
  const [contestId, setContestId] = useState<string>();

  const handleUploadTypeChange = (uploadType: UploadType) => {
    setUploadType(uploadType);
  };

  const handleContestChange = (contestId: string) => {
    if (contestId)
      setContestId(contestId);
    else
      setContestId(undefined);
  }

  const handleUpload = async (file: File) => {
    const uploadResult = await uploadArchive(file, undefined, 'contest');
    if (!uploadResult) {
      setContestId(undefined);
      setUploadType('' as UploadType);

      return { success: false, errorMessage: 'Failed to upload file to S3.  Please check that bucket exists.' };
    }

    const contestResult = await contestService.uploadContestZip(file, contestId);
    if (contestResult.isOk()) {
      return { success: true };
    }

    setContestId(undefined);
    setUploadType('' as UploadType);

    let errorMessage = `Oops, something went wrong. Please make sure your ZIP file contains
    all required CSVs and that all CSVs contain all required fields.`;

    // use custom error message from backend:
    if (contestResult.error.result.isJust() && contestResult.error.result.value?.message) {
      const responseMessge = contestResult.error.result.value.message;
      console.error("Error uploading zip: ", responseMessge);
      if (responseMessge?.includes('Invalid contest name') || responseMessge?.includes('Contest already exists')) {
        errorMessage = responseMessge;
      }
    }

    return { success: false, errorMessage };
  }

  return (
    <>
      <Header />
      <Box sx={styles.root}>
        <ManageContestsPanel
          uploadType={uploadType}
          onUploadTypeChange={handleUploadTypeChange}
          onContestChange={handleContestChange}
        />
        <ManageContestsSheet
          disabled={!uploadType}
          onUpload={handleUpload}
        />
      </Box>
    </>
  );
}
